<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="users"
      :options.sync="options"
      :loading="loading"
      :totalData="totalUsers"
      :refresh-table="getData"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >     
        <template v-slot:body-prepend>
            <TableFilterMerchantManagement :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
        </template>
        <template slot="action" slot-scope="{ item }">
          <TableActionMerchantManagement
            :item="item"
            :isDisabledBlock="isDisabledBlock"
            :getActionIcon="getActionIcon"
            :getActionLabel="getActionLabel"
            @view="viewItem"
            @edit="editItem"
            @blockUnblock="handleBlockUnblock"
          />
      </template>
            <template v-slot:custom_status="{ item }">
        <div class="d-flex flex-column" :style="{ padding: '8px 0' }">
          {{ getStatusLabel(item.status) }}
      </div>

      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="800px" @click:outside="close">
        <v-card>
          <v-form>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row style="align-items: center">
                  <v-col cols="10" sm="4"> Username </v-col>
                  <v-col cols="2" sm="1"> : </v-col>
                  <v-col cols="12" sm="7">
                    <v-row>
                      <v-col cols="12" class="py-0">
                        <v-text-field
                          id="username"
                          ref="username"
                          v-model="editedItem.username"
                          @change="$v.editedItem.username.$touch()"
                          @blur="$v.editedItem.username.$touch()"
                          :error-messages="usernameErrors"
                        />
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-switch
                          v-model="changePassword"
                          label="ubah username tanpa mengubah password saat ini"
                          color="orange"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row style="align-items: center">
                  <v-col cols="10" sm="4"> MID </v-col>
                  <v-col cols="2" sm="1"> : </v-col>
                  <v-col cols="12" sm="7">
                    {{ editedItem.mid }}
                  </v-col>
                </v-row>
                <v-row style="align-items: center">
                  <v-col cols="10" sm="4"> Last Login </v-col>
                  <v-col cols="2" sm="1"> : </v-col>
                  <v-col cols="12" sm="7">
                    {{ editedItem.last_login_at }}
                  </v-col>
                </v-row>
                <v-row style="align-items: center">
                  <v-col cols="10" sm="4"> Created Date </v-col>
                  <v-col cols="2" sm="1"> : </v-col>
                  <v-col cols="12" sm="7">
                    {{ editedItem.created_at }}
                  </v-col>
                </v-row>
                <v-row style="align-items: center">
                  <v-col cols="10" sm="4"> Force Change Password </v-col>
                  <v-col cols="2" sm="1"> : </v-col>
                  <v-col cols="12" sm="7">
                    {{ editedItem.password_change_name }}
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn
                v-if="!view"
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="loading"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    <v-dialog v-model="dialogConfirm" width="610" persistent>
      <div style="width: 100%; height: 10px; background-color: #146b76"></div> 
      <confirm-dialog
        :title="getDialogTitle(selectedData.status)"
        :confirmationText="getConfirmationText(selectedData.status)"
        v-on:closeCancelParent="closeDialogConfirm"
        v-on:confirmParent="confirmAction"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import merchantManagementMixin from '../../components/merchant-management/merchantManagementMixin';
import { TableFilterMerchantManagement, TableActionMerchantManagement} from '../../components/merchant-management/components';

export default {
  components: {
    confirmDialog: () => import('../../components/ConfirmDialog.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableFilterMerchantManagement,
    TableActionMerchantManagement
  },
  mixins: [validationMixin, merchantManagementMixin],

};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>

<style scoped>
.td1 {
  width: 35%;
  text-align: left;
  vertical-align: top;
}
.td2 {
  width: 15%;
  text-align: center;
  vertical-align: top;
}
.td3 {
  width: 50%;
  text-align: left;
  vertical-align: top;
}
</style>
